module.exports = __webpack_public_path__ + "assets/img/d1e4-ba.svg";